module.exports = __webpack_public_path__ + "static/media/20ECE30.8f826231.jpg";